export default __webpack_public_path__ + "media/color/arnx-a3689bb6.svg";